// Form + footer helpers extracted from RoadOptionsPage to keep each
// hand-written file inside the 400-line soft limit (#1152).

import { useTranslation } from 'react-i18next';
import { Button, Input, useEditorGuard } from '../../../ui/index.js';
import { parseSortOrderInput } from '../../../shared/index.js';

export function RoadOptionForm({
  name,
  sortOrder,
  active,
  readOnly = false,
  onChangeName,
  onChangeSortOrder,
}: {
  name: string;
  sortOrder: string;
  active: boolean;
  readOnly?: boolean;
  onChangeName: (value: string) => void;
  onChangeSortOrder: (value: string) => void;
}) {
  const { t } = useTranslation('roadOptions');
  const sortOrderInvalid = sortOrder.trim().length > 0 && parseSortOrderInput(sortOrder) === null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <label style={{ display: 'flex', flexDirection: 'column', gap: 5, fontSize: 12 }}>
        <span style={{ color: 'var(--fg-3)' }}>{t('fields.name')} *</span>
        <Input value={name} onChange={onChangeName} readOnly={readOnly} />
      </label>
      <label style={{ display: 'flex', flexDirection: 'column', gap: 5, fontSize: 12 }}>
        <span style={{ color: 'var(--fg-3)' }}>{t('fields.sortOrder')}</span>
        <Input
          value={sortOrder}
          onChange={onChangeSortOrder}
          readOnly={readOnly}
          aria-invalid={sortOrderInvalid}
        />
        <span style={{ color: sortOrderInvalid ? 'var(--status-error-fg)' : 'var(--fg-3)' }}>
          {sortOrderInvalid ? t('errors.sortOrderInvalid') : t('fields.sortOrderHelp')}
        </span>
      </label>
      {!active && (
        <span style={{ color: 'var(--fg-3)', fontSize: 12 }}>{t('hints.archivedRow')}</span>
      )}
    </div>
  );
}

// WHY: Cancel must call `useEditorGuard().confirmDestructive(onClose)` to
// prompt on dirty close. The EditorGuardContext provider only wraps the
// EditorModal `children` subtree, not a `footer` prop, so action buttons
// render inline at the bottom of children. Mirrors ArrivalCitiesPage.
export function EditorFooter({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        marginTop: 12,
        marginLeft: -16,
        marginRight: -16,
        marginBottom: -16,
        padding: '12px 16px',
        borderTop: '1px solid var(--border-2)',
        display: 'flex',
        gap: 8,
        justifyContent: 'flex-end',
      }}
    >
      {children}
    </div>
  );
}

export function CancelButton({ onClose, label }: { onClose: () => void; label: string }) {
  const { confirmDestructive } = useEditorGuard();
  return (
    <Button kind="ghost" onClick={() => confirmDestructive(onClose)}>
      {label}
    </Button>
  );
}
